import Loading from 'react-loading-bar';
import 'react-loading-bar/dist/index.css';
import { useSelector, useThemeConfig } from '@topwrite/common';

export default function LoadingBar() {

    const { loading } = useSelector('page');
    const { primaryColor } = useThemeConfig();

    return <Loading show={loading} color={primaryColor} />;
}
